/* eslint-disable indent */
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { initializeUser } from '../reducers/userReducer'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'
import Pages from './Pages'

const Achievements = () => {
  const dispatch = useDispatch()
  const [aUsers, setAUsers] = useState([])
  const [page, setPage] = useState(1)
  const [sortBy, setSortBy] = useState(null)
  const [sortOrder, setSortOrder] = useState('asc') // Nouseva oletuksena

  const user = useSelector(state => state.user)
  useEffect(() => {
    const loadData = async () => {
      const userData = await dispatch(initializeUser())
      if (userData) {
        const token = userData.oauth_token || userData.id
        const users = await axios.get('/api/achievements/' + token + '/' + page)
        setAUsers(users.data)
      }
    }
    loadData()
  }, [])

  const handlePageChange = async page => {
    const users = await axios.get(
      '/api/achievements/' + user.oauth_token + '/' + page
    )
    setAUsers(users.data)
    setPage(page)
  }

  const handleSortChange = column => {
    const newSortOrder =
      sortBy === column && sortOrder === 'asc' ? 'desc' : 'asc'
    setSortBy(column)
    setSortOrder(newSortOrder)

    const sorted = [...aUsers].sort((a, b) => {
      const valueA =
        column === 'general'
          ? a.Categorys.category2 +
            a.Categorys.category3 +
            a.Categorys.category4
          : a.Categorys[column] || 0
      const valueB =
        column === 'general'
          ? b.Categorys.category2 +
            b.Categorys.category3 +
            b.Categorys.category4
          : b.Categorys[column] || 0

      if (valueA > valueB) return newSortOrder === 'asc' ? 1 : -1
      if (valueA < valueB) return newSortOrder === 'asc' ? -1 : 1
      return 0
    })
    setAUsers(sorted)
  }

  const dateFin = dateStr => {
    const date = new Date(dateStr)
    const formattedDate = date.toLocaleString('fi-FI', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })

    return formattedDate
  }

  const headers = [
    { label: 'Sija', key: null },
    { label: 'Käyttäjä', key: 'LoginName' },
    { label: 'Pisteet', key: 'sum' },
    { label: 'Yleiset', key: 'general' },
    { label: 'Joukkue', key: 'category2' },
    { label: 'Ottelut', key: 'category3' },
    { label: 'Manageri', key: 'category4' },
    { label: 'Erityiset', key: 'category5' },
    { label: 'Supporter', key: 'category6' },
    { label: 'Arena', key: 'category7' },
    { label: 'Piilotetut', key: 'category0' },
  ]

  const topTeamsTable = list => {
    return list.length > 0 ? (
      <>
        <Table striped bordered variant="dark" size="sm">
          <thead>
            <tr>
              <td colSpan={11}>Päivitetty viimeksi {dateFin(list[0].Date)}</td>
            </tr>
            <tr>
              {headers.map(header => (
                <th
                  key={header.label}
                  onClick={() => header.key && handleSortChange(header.key)}
                  style={{ cursor: header.key ? 'pointer' : 'default' }}
                >
                  {header.label}{' '}
                  {sortBy === header.key && (sortOrder === 'asc' ? '▲' : '▼')}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list.map((team, i) => (
              <tr
                key={team.UserID + sortBy + sortOrder}
                style={{
                  color:
                    user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  fontWeight:
                    user.loginName === team.LoginName ? 'bold' : 'normal',
                }}
              >
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {page * 100 - 100 + i + 1}
                </td>
                <td>
                  <a
                    href={`https://hattrick.org/goto.ashx?path=/Club/Achievements/?userID=${team.UserID}&teamID=${team.TeamID}`}
                    style={{
                      textDecoration: 'none',
                      color:
                        user.loginName === team.LoginName
                          ? '#28a745'
                          : '#ffffff',
                    }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {team.LoginName}
                  </a>
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.sum || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category2 +
                    team.Categorys.category3 +
                    team.Categorys.category4 || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category2 || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category3 || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category4 || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category5 || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category6 || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category7 || 0}
                </td>
                <td
                  style={{
                    color:
                      user.loginName === team.LoginName ? '#28a745' : '#ffffff',
                  }}
                >
                  {team.Categorys.category0 || 0}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pages
          currentPage={page}
          totalPages={20}
          onPageChange={handlePageChange}
        />
      </>
    ) : (
      <Table striped bordered hover variant="dark" size="sm">
        <tbody>
          <tr>
            <td>
              <Spinner animation="border" />
            </td>
          </tr>
        </tbody>
      </Table>
    )
  }

  ////console.log(userTeams)

  return topTeamsTable(aUsers)
}

export default Achievements
